export default {
	CLOSED: 'c',
	LOADING: 'l',
	DIALOG: 'd',
	DELETE: 'r',
	ERROR: 'e',
	INFO: 'i',
}